import { RegisterForm } from "../components/RegisterForm";

export function RegisterPage() {
	return <RegisterForm />;
}
